// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const DinoRexSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'dino-rex-abilityBlack',
    metadata: {
      frames: {
        'dino-rex-abilityBlack-0': {
          frame: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-1': {
          frame: {
            x: 384,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-2': {
          frame: {
            x: 768,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-3': {
          frame: {
            x: 1152,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-4': {
          frame: {
            x: 1536,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-5': {
          frame: {
            x: 1920,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-6': {
          frame: {
            x: 2304,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-7': {
          frame: {
            x: 2688,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-8': {
          frame: {
            x: 3072,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-9': {
          frame: {
            x: 3456,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-10': {
          frame: {
            x: 3840,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-11': {
          frame: {
            x: 4224,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-12': {
          frame: {
            x: 4608,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-13': {
          frame: {
            x: 4992,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-14': {
          frame: {
            x: 5376,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-15': {
          frame: {
            x: 5760,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-16': {
          frame: {
            x: 6144,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-17': {
          frame: {
            x: 6528,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-18': {
          frame: {
            x: 6912,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-19': {
          frame: {
            x: 7296,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-20': {
          frame: {
            x: 7680,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-21': {
          frame: {
            x: 8064,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-22': {
          frame: {
            x: 8448,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-23': {
          frame: {
            x: 8832,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityBlack-24': {
          frame: {
            x: 9216,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dino-rex/abilityBlack.png',
        size: {
          w: 9600,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'dino-rex-abilityBlack': [
          'dino-rex-abilityBlack-0',
          'dino-rex-abilityBlack-1',
          'dino-rex-abilityBlack-2',
          'dino-rex-abilityBlack-3',
          'dino-rex-abilityBlack-4',
          'dino-rex-abilityBlack-5',
          'dino-rex-abilityBlack-6',
          'dino-rex-abilityBlack-7',
          'dino-rex-abilityBlack-8',
          'dino-rex-abilityBlack-9',
          'dino-rex-abilityBlack-10',
          'dino-rex-abilityBlack-11',
          'dino-rex-abilityBlack-12',
          'dino-rex-abilityBlack-13',
          'dino-rex-abilityBlack-14',
          'dino-rex-abilityBlack-15',
          'dino-rex-abilityBlack-16',
          'dino-rex-abilityBlack-17',
          'dino-rex-abilityBlack-18',
          'dino-rex-abilityBlack-19',
          'dino-rex-abilityBlack-20',
          'dino-rex-abilityBlack-21',
          'dino-rex-abilityBlack-22',
          'dino-rex-abilityBlack-23',
          'dino-rex-abilityBlack-24',
        ],
      },
    },
  },
  {
    name: 'dino-rex-abilityRed',
    metadata: {
      frames: {
        'dino-rex-abilityRed-0': {
          frame: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-1': {
          frame: {
            x: 384,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-2': {
          frame: {
            x: 768,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-3': {
          frame: {
            x: 1152,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-4': {
          frame: {
            x: 1536,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-5': {
          frame: {
            x: 1920,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-6': {
          frame: {
            x: 2304,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-7': {
          frame: {
            x: 2688,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-8': {
          frame: {
            x: 3072,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-9': {
          frame: {
            x: 3456,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-10': {
          frame: {
            x: 3840,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-11': {
          frame: {
            x: 4224,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-12': {
          frame: {
            x: 4608,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-13': {
          frame: {
            x: 4992,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-14': {
          frame: {
            x: 5376,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-15': {
          frame: {
            x: 5760,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-16': {
          frame: {
            x: 6144,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-17': {
          frame: {
            x: 6528,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-18': {
          frame: {
            x: 6912,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-19': {
          frame: {
            x: 7296,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-20': {
          frame: {
            x: 7680,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-21': {
          frame: {
            x: 8064,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-22': {
          frame: {
            x: 8448,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-23': {
          frame: {
            x: 8832,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityRed-24': {
          frame: {
            x: 9216,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dino-rex/abilityRed.png',
        size: {
          w: 9600,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'dino-rex-abilityRed': [
          'dino-rex-abilityRed-0',
          'dino-rex-abilityRed-1',
          'dino-rex-abilityRed-2',
          'dino-rex-abilityRed-3',
          'dino-rex-abilityRed-4',
          'dino-rex-abilityRed-5',
          'dino-rex-abilityRed-6',
          'dino-rex-abilityRed-7',
          'dino-rex-abilityRed-8',
          'dino-rex-abilityRed-9',
          'dino-rex-abilityRed-10',
          'dino-rex-abilityRed-11',
          'dino-rex-abilityRed-12',
          'dino-rex-abilityRed-13',
          'dino-rex-abilityRed-14',
          'dino-rex-abilityRed-15',
          'dino-rex-abilityRed-16',
          'dino-rex-abilityRed-17',
          'dino-rex-abilityRed-18',
          'dino-rex-abilityRed-19',
          'dino-rex-abilityRed-20',
          'dino-rex-abilityRed-21',
          'dino-rex-abilityRed-22',
          'dino-rex-abilityRed-23',
          'dino-rex-abilityRed-24',
        ],
      },
    },
  },
  {
    name: 'dino-rex-abilityYellow',
    metadata: {
      frames: {
        'dino-rex-abilityYellow-0': {
          frame: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-1': {
          frame: {
            x: 384,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-2': {
          frame: {
            x: 768,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-3': {
          frame: {
            x: 1152,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-4': {
          frame: {
            x: 1536,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-5': {
          frame: {
            x: 1920,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-6': {
          frame: {
            x: 2304,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-7': {
          frame: {
            x: 2688,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-8': {
          frame: {
            x: 3072,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-9': {
          frame: {
            x: 3456,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-10': {
          frame: {
            x: 3840,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-11': {
          frame: {
            x: 4224,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-12': {
          frame: {
            x: 4608,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-13': {
          frame: {
            x: 4992,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-14': {
          frame: {
            x: 5376,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-15': {
          frame: {
            x: 5760,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-16': {
          frame: {
            x: 6144,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-17': {
          frame: {
            x: 6528,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-18': {
          frame: {
            x: 6912,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-19': {
          frame: {
            x: 7296,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-20': {
          frame: {
            x: 7680,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-21': {
          frame: {
            x: 8064,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-22': {
          frame: {
            x: 8448,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-23': {
          frame: {
            x: 8832,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-abilityYellow-24': {
          frame: {
            x: 9216,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dino-rex/abilityYellow.png',
        size: {
          w: 9600,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'dino-rex-abilityYellow': [
          'dino-rex-abilityYellow-0',
          'dino-rex-abilityYellow-1',
          'dino-rex-abilityYellow-2',
          'dino-rex-abilityYellow-3',
          'dino-rex-abilityYellow-4',
          'dino-rex-abilityYellow-5',
          'dino-rex-abilityYellow-6',
          'dino-rex-abilityYellow-7',
          'dino-rex-abilityYellow-8',
          'dino-rex-abilityYellow-9',
          'dino-rex-abilityYellow-10',
          'dino-rex-abilityYellow-11',
          'dino-rex-abilityYellow-12',
          'dino-rex-abilityYellow-13',
          'dino-rex-abilityYellow-14',
          'dino-rex-abilityYellow-15',
          'dino-rex-abilityYellow-16',
          'dino-rex-abilityYellow-17',
          'dino-rex-abilityYellow-18',
          'dino-rex-abilityYellow-19',
          'dino-rex-abilityYellow-20',
          'dino-rex-abilityYellow-21',
          'dino-rex-abilityYellow-22',
          'dino-rex-abilityYellow-23',
          'dino-rex-abilityYellow-24',
        ],
      },
    },
  },
  {
    name: 'dino-rex-attack',
    metadata: {
      frames: {
        'dino-rex-attack-0': {
          frame: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-1': {
          frame: {
            x: 384,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-2': {
          frame: {
            x: 768,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-3': {
          frame: {
            x: 1152,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-4': {
          frame: {
            x: 1536,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-5': {
          frame: {
            x: 1920,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-6': {
          frame: {
            x: 2304,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-7': {
          frame: {
            x: 2688,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-8': {
          frame: {
            x: 3072,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-9': {
          frame: {
            x: 3456,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-10': {
          frame: {
            x: 3840,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-11': {
          frame: {
            x: 4224,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-12': {
          frame: {
            x: 4608,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-13': {
          frame: {
            x: 4992,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-14': {
          frame: {
            x: 5376,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-15': {
          frame: {
            x: 5760,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-16': {
          frame: {
            x: 6144,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-17': {
          frame: {
            x: 6528,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-18': {
          frame: {
            x: 6912,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-19': {
          frame: {
            x: 7296,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attack-20': {
          frame: {
            x: 7680,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dino-rex/attack.png',
        size: {
          w: 8064,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'dino-rex-attack': [
          'dino-rex-attack-0',
          'dino-rex-attack-1',
          'dino-rex-attack-2',
          'dino-rex-attack-3',
          'dino-rex-attack-4',
          'dino-rex-attack-5',
          'dino-rex-attack-6',
          'dino-rex-attack-7',
          'dino-rex-attack-8',
          'dino-rex-attack-9',
          'dino-rex-attack-10',
          'dino-rex-attack-11',
          'dino-rex-attack-12',
          'dino-rex-attack-13',
          'dino-rex-attack-14',
          'dino-rex-attack-15',
          'dino-rex-attack-16',
          'dino-rex-attack-17',
          'dino-rex-attack-18',
          'dino-rex-attack-19',
          'dino-rex-attack-20',
        ],
      },
    },
  },
  {
    name: 'dino-rex-attackB1Start',
    metadata: {
      frames: {
        'dino-rex-attackB1Start-0': {
          frame: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB1Start-1': {
          frame: {
            x: 384,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB1Start-2': {
          frame: {
            x: 768,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB1Start-3': {
          frame: {
            x: 1152,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB1Start-4': {
          frame: {
            x: 1536,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB1Start-5': {
          frame: {
            x: 1920,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB1Start-6': {
          frame: {
            x: 2304,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB1Start-7': {
          frame: {
            x: 2688,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB1Start-8': {
          frame: {
            x: 3072,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB1Start-9': {
          frame: {
            x: 3456,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dino-rex/attackB1Start.png',
        size: {
          w: 3840,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'dino-rex-attackB1Start': [
          'dino-rex-attackB1Start-0',
          'dino-rex-attackB1Start-1',
          'dino-rex-attackB1Start-2',
          'dino-rex-attackB1Start-3',
          'dino-rex-attackB1Start-4',
          'dino-rex-attackB1Start-5',
          'dino-rex-attackB1Start-6',
          'dino-rex-attackB1Start-7',
          'dino-rex-attackB1Start-8',
          'dino-rex-attackB1Start-9',
        ],
      },
    },
  },
  {
    name: 'dino-rex-attackB2Loop',
    metadata: {
      frames: {
        'dino-rex-attackB2Loop-0': {
          frame: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB2Loop-1': {
          frame: {
            x: 384,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB2Loop-2': {
          frame: {
            x: 768,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB2Loop-3': {
          frame: {
            x: 1152,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB2Loop-4': {
          frame: {
            x: 1536,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dino-rex/attackB2Loop.png',
        size: {
          w: 1920,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'dino-rex-attackB2Loop': [
          'dino-rex-attackB2Loop-0',
          'dino-rex-attackB2Loop-1',
          'dino-rex-attackB2Loop-2',
          'dino-rex-attackB2Loop-3',
          'dino-rex-attackB2Loop-4',
        ],
      },
    },
  },
  {
    name: 'dino-rex-attackB3End',
    metadata: {
      frames: {
        'dino-rex-attackB3End-0': {
          frame: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB3End-1': {
          frame: {
            x: 384,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB3End-2': {
          frame: {
            x: 768,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB3End-3': {
          frame: {
            x: 1152,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB3End-4': {
          frame: {
            x: 1536,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB3End-5': {
          frame: {
            x: 1920,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-attackB3End-6': {
          frame: {
            x: 2304,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dino-rex/attackB3End.png',
        size: {
          w: 2688,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'dino-rex-attackB3End': [
          'dino-rex-attackB3End-0',
          'dino-rex-attackB3End-1',
          'dino-rex-attackB3End-2',
          'dino-rex-attackB3End-3',
          'dino-rex-attackB3End-4',
          'dino-rex-attackB3End-5',
          'dino-rex-attackB3End-6',
        ],
      },
    },
  },
  {
    name: 'dino-rex-exhaust',
    metadata: {
      frames: {
        'dino-rex-exhaust-0': {
          frame: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-exhaust-1': {
          frame: {
            x: 384,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-exhaust-2': {
          frame: {
            x: 768,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-exhaust-3': {
          frame: {
            x: 1152,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dino-rex/exhaust.png',
        size: {
          w: 1536,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'dino-rex-exhaust': [
          'dino-rex-exhaust-0',
          'dino-rex-exhaust-1',
          'dino-rex-exhaust-2',
          'dino-rex-exhaust-3',
        ],
      },
    },
  },
  {
    name: 'dino-rex-idle',
    metadata: {
      frames: {
        'dino-rex-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'dino-rex-idle-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'dino-rex-idle-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'dino-rex-idle-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'dino-rex-idle-4': {
          frame: {
            x: 512,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dino-rex/idle.png',
        size: {
          w: 640,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'dino-rex-idle': [
          'dino-rex-idle-0',
          'dino-rex-idle-1',
          'dino-rex-idle-2',
          'dino-rex-idle-3',
          'dino-rex-idle-4',
        ],
      },
    },
  },
  {
    name: 'dino-rex-run',
    metadata: {
      frames: {
        'dino-rex-run-0': {
          frame: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-run-1': {
          frame: {
            x: 384,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-run-2': {
          frame: {
            x: 768,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-run-3': {
          frame: {
            x: 1152,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-run-4': {
          frame: {
            x: 1536,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-run-5': {
          frame: {
            x: 1920,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-run-6': {
          frame: {
            x: 2304,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-run-7': {
          frame: {
            x: 2688,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dino-rex/run.png',
        size: {
          w: 3072,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'dino-rex-run': [
          'dino-rex-run-0',
          'dino-rex-run-1',
          'dino-rex-run-2',
          'dino-rex-run-3',
          'dino-rex-run-4',
          'dino-rex-run-5',
          'dino-rex-run-6',
          'dino-rex-run-7',
        ],
      },
    },
  },
  {
    name: 'dino-rex-stomp',
    metadata: {
      frames: {
        'dino-rex-stomp-0': {
          frame: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-stomp-1': {
          frame: {
            x: 384,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-stomp-2': {
          frame: {
            x: 768,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-stomp-3': {
          frame: {
            x: 1152,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
        'dino-rex-stomp-4': {
          frame: {
            x: 1536,
            y: 0,
            w: 384,
            h: 128,
          },
          sourceSize: {
            w: 384,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 384,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/dino-rex/stomp.png',
        size: {
          w: 1920,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'dino-rex-stomp': [
          'dino-rex-stomp-0',
          'dino-rex-stomp-1',
          'dino-rex-stomp-2',
          'dino-rex-stomp-3',
          'dino-rex-stomp-4',
        ],
      },
    },
  },
];
